<div class="h-screen p-20 text-center text-white bg-primary">
  <div class="w-full p-10">
    <app-logo class="flex-1 max-w-[300px]"></app-logo>
  </div>

  <div class="font-bold md:text-3xl">
    {{ 'shared.errors.pageNotFound' | translate }}
  </div>
</div>
